import { setAccessTokenProvider, setTokenRefreshHandler } from '@metaonia/api-client';

import { getAccessToken, refreshTokens } from '@/lib/auth/get-access-token';

export function initializeApiClient(): void {
  setAccessTokenProvider(getAccessToken);
  setTokenRefreshHandler(refreshTokens);
}
